const getters = {
    language: state => state.app.language,
    loggedIn: state => state.app.user && state.app.token,
    token: state => state.app.token,
    type: state => state.app.type,
    isReferralCodeExist: state => state.refRegister.isReferralCodeExist,
    user: state => state.app.user,
    permissions: state => state.app.user && state.app.user.permissions && state.app.user.permissions.length && state.app.user.permissions.map('name'),
    allDataFilled: state => {
        if (!state.app.user) {
            return null
        }

        const { firstName, lastName, taxId, email, phoneNumber, passportNumber, status } = state.app.user

        return !!(firstName && lastName && taxId && email && phoneNumber && passportNumber) &&
            ['success'].includes(status)
    }
}

export default getters
